<template>
  <div class="min-h-screen bg-base text-zinc-800 transition-colors duration-300 dark:bg-base-dark dark:text-zinc-50">
    <AppNavbar />
    <router-view />
    <ConsentWall />
  </div>
</template>

<script setup>
import AppNavbar from './components/AppNavbar.vue';
import ConsentWall from './components/ConsentWall.vue';
import { useThemeStore } from './stores/theme';

useThemeStore();
</script>
